import {
  customer_profile_overall_v4,
  customer_profile_cluster_v4,
  customer_profile_area_v4,
  customer_profile_branch_v4,
} from "../../v4-services/reports/customer_profiling_service";
import { actionTypes } from "../action_types";

const createCustomerProfileAction =
  (fetchFunction, actionType) => (data) => (dispatch) => {
    return fetchFunction(data).then((resp) => {
      if (resp.problem === null) {
        dispatch({
          type: actionType,
          payload: resp.data === null ? { customerProfiles: [] } : resp.data,
        });
      }
      return Promise.resolve(resp);
    });
  };

export const GetCustomerProfileOverallV4 = createCustomerProfileAction(
  customer_profile_overall_v4,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_OVERALL
);

export const GetCustomerProfileClusterV4 = createCustomerProfileAction(
  customer_profile_cluster_v4,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_CLUSTER
);

export const GetCustomerProfileAreaV4 = createCustomerProfileAction(
  customer_profile_area_v4,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_AREA
);

export const GetCustomerProfileBranchV4 = createCustomerProfileAction(
  customer_profile_branch_v4,
  actionTypes.REPORTS_CUSTOMERPROFILING_GET_BRANCH
);
